/**
 * Extract all unique rowIds from table data by reading the first non-null cell of each row
 * @param {FormTableData} tableData
 * @returns {string[]}
 */
export function getAllRowIds(tableData) {
  /** @type {string[]} */
  const rowIds = [];
  tableData.groups.forEach((group) => {
    group.rows.forEach((row) => {
      const firstCell = row.cells.find((c) => c.text != null);
      if (firstCell?.text) {
        rowIds.push(firstCell.text.rowId);
      }
    });
  });
  return rowIds;
}

/**
 * Build a map from rowId to selected colId for fast lookup
 * @param {FormTableSelection[]} selections
 * @returns {Record<string, string>}
 */
export function buildSelectionMap(selections) {
  /** @type {Record<string, string>} */
  const map = {};
  selections.forEach((s) => { map[s.rowId] = s.colId; });
  return map;
}

export const BASE_COLUMN_ROW_ID = 'KeepedItemId';

/**
 * Get the colId of the base column selection, or null if none
 * @param {FormTableSelection[]} selections
 * @returns {string | null}
 */
export function getBaseColumnId(selections) {
  const entry = selections.find((s) => s.rowId === BASE_COLUMN_ROW_ID);
  return entry ? entry.colId : null;
}

/**
 * Build selections for an entire column: base_column entry + one entry per row
 * @param {string[]} allRowIds
 * @param {string} colId
 * @returns {FormTableSelection[]}
 */
export function buildColumnSelections(allRowIds, colId) {
  return [
    { rowId: BASE_COLUMN_ROW_ID, colId },
    ...allRowIds.map((rowId) => ({ rowId, colId })),
  ];
}
